module.exports = __webpack_public_path__ + "img/Rollator_Icon_white.3106dd12.png";